import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextBlock from '../TextBlock/TextBlock';
import RoundIcon from '../RoundIcon/RoundIcon';
import ClickableLabel from '../ClickableLabel/ClickableLabel';
import SectionBlock from '../SectionBlock/SectionBlock';
import BulletStyle from '../TextBlock/constants/BulletStyle';
import ProductTypes from '../../constants/ProductTypes';
import ReportSectionHeading from './../ReportSectionHeading/ReportSectionHeading';
import style from './style/consultanttextsection.scss';

export default class ConsultantTextSection extends Component {
    constructor(props) {
        super(props);

        this.state = {
            expanded: false,
            openToolTip: false,
            classTooltip: 'display_none'
        };

        this.toggleText = this.toggleText.bind(this);
        this.showTooltipModalHandler = this.showTooltipModalHandler.bind(this);
    }

    toggleText(event) {
        this.props.resize(event);

        this.setState({
            expanded: !this.state.expanded
        });
    }

    showTooltipModalHandler() {
        if (this.state.openToolTip === false) {
            this.setState({
                ...this.state,
                openToolTip: true,
                classTooltip: 'displayBlock'
            });
        } else if (this.state.openToolTip === true) {
            this.setState({
                ...this.state,
                openToolTip: false,
                classTooltip: 'display_none'
            });
        }
    }

    render() {
        const {
            introHeading,
            title,
            text,
            iconText,
            bulletStyle,
            isExpandable,
            expandLabel,
            shrinkLabel,
            classes,
            children,
            content
        } = this.props;

        let textBlockContent = null,
            expandBar = null;

        // component can also just render children in case of selection advice where no bullets are going to be rendered
        if (!bulletStyle && children) {
            textBlockContent = children;
        } else {
            switch (bulletStyle) {

                case BulletStyle.POSITIVE:
                case BulletStyle.NEGATIVE:
                case BulletStyle.REGULAR:
                case BulletStyle.QUESTION_MARK:
                    textBlockContent = <div
                        className={`${style.bulletList} ${style[bulletStyle]}`}
                        dangerouslySetInnerHTML={{ __html: text }}
                    />;
                    break;

                case BulletStyle.NONE:
                default:

                    textBlockContent = <div className={ style.textPadding } dangerouslySetInnerHTML={{ __html: text }}/>;
                    break;
            }
        }

        if (isExpandable) {
            expandBar = <div className={ `${style.readMoreSection} ${!this.state.expanded ? style.gradientOverlay : ''}` } >
                <ClickableLabel isExpanded={this.state.expanded} classes={{ root: style.readMoreLink }} onMouseDown={ event => {
                    event.stopPropagation();
                }} onClick={ this.toggleText }>
                    { !this.state.expanded ? expandLabel : shrinkLabel }
                    <RoundIcon
                        classes={{
                            root: `${style.toggleFullText} ${classes.roundIcon.scoreRoundIcon}`,
                            roundIconFigureWrapper: classes.roundIconFigureWrapper__withExpandIcon
                        }}
                        circleSize={ 1.2 }
                        iconSize={ 0.875 }
                        iconType={ !this.state.expanded ? 'chevron-down' : 'times' }
                    />
                </ClickableLabel>
            </div>;
        }

        return (
            <SectionBlock classes={{
                root: `${style.consultantTextSection} ${classes.root}`,
                badge: classes.badge
            }}>
                <ReportSectionHeading
                    title={ title }
                    iconType={ this.props.isPreCalculated ? 'desktop' : 'user-edit' }
                    iconText={ iconText }
                    introHeading={ !!introHeading }
                    introHeadingIcon={ 'info-circle' }
                    introHeadingAction={ this.showTooltipModalHandler }
                    classes={{
                        reportSectionHeading: classes.reportSectionHeading,
                        roundIcon: {
                            root: classes.roundIcon.root,
                            roundIconFigureWrapper: classes.roundIcon.roundIconFigureWrapper
                        }
                    }}
                />

                { introHeading ? <div className={ `${style.intro_tooltip_container} ${this.state.classTooltip}`}>
                    <p className={ style.intro_header }>{ introHeading ? introHeading : null }</p>
                </div> : null }

                <TextBlock>
                    { textBlockContent }
                    { content }
                </TextBlock>
                { expandBar }
            </SectionBlock>
        );
    }
}

ConsultantTextSection.propTypes = {
    children: PropTypes.object,
    title: PropTypes.string,
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    iconText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    expandLabel: PropTypes.string,
    shrinkLabel: PropTypes.string,
    isExpandable: PropTypes.bool,
    resize: PropTypes.func.isRequired,
    bulletStyle: PropTypes.oneOf([BulletStyle.POSITIVE, BulletStyle.NEGATIVE, BulletStyle.QUESTION_MARK, BulletStyle.REGULAR, BulletStyle.NONE]),
    content: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.array]),
    introHeading: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    productType: PropTypes.string,
    classes: PropTypes.object,
    isPreCalculated: PropTypes.bool
};

ConsultantTextSection.defaultProps = {
    children: {},
    title: '',
    text: '',
    iconText: '',
    whatever: '',
    expandLabel: '',
    shrinkLabel: '',
    isExpandable: false,
    resize: null,
    bulletStyle: BulletStyle.NONE,
    content: '',
    introHeading: '',
    productType: '',
    classes: {
        root: '',
        reportSectionHeading: '',
        roundIcon: {
            root: '',
            roundIconFigureWrapper: ''
        },
        badge: {}
    },
    isPreCalculated: false
};
